import { ECexBotFilter } from 'types/bots';
import { ICexOrder } from 'types/cex/orders';

const KNOWN_BOT_FILTERS = new Set<string>(Object.values(ECexBotFilter));

export const mapCexBotToFilter = (bot?: string | null): ECexBotFilter => {
  const normalizedBot = (bot ?? '').trim();

  switch (normalizedBot) {
    case 'buysell':
      return ECexBotFilter.buy_sell;
    case 'orderbook':
      return ECexBotFilter.order_book;
    case 'orderbook_dynamic':
      return ECexBotFilter.orderbook_dynamic;
    case 'dn-orderbook':
    case 'dn_orderbook':
    case 'delta_neutral_ob':
      return ECexBotFilter.dn_orderbook;
    case 'order-manager-bot':
      return ECexBotFilter.order_manager;
    case 'counter-order':
      return ECexBotFilter.counter_order;
    case 'ob_protection':
      return ECexBotFilter.abuse_protection;
    case '':
      return ECexBotFilter.unknown;
    default:
      return KNOWN_BOT_FILTERS.has(normalizedBot)
        ? (normalizedBot as ECexBotFilter)
        : ECexBotFilter.unknown;
  }
};

export const isKnownCexBotFilter = (botId: string): boolean => KNOWN_BOT_FILTERS.has(botId);

export const filterOrdersByBotFilters = <T extends { bot?: string | null }>(
  orders: T[],
  botFilters: string[],
): T[] => {
  if (botFilters.length === 0) {
    return orders;
  }

  const allowedFilters = new Set(botFilters);

  return orders.filter(order => {
    const filterId = mapCexBotToFilter(order.bot);

    if (filterId === ECexBotFilter.unknown) {
      const rawBot = (order.bot ?? '').trim();

      if (rawBot === '' || rawBot !== ECexBotFilter.unknown) {
        return true;
      }
    }

    return allowedFilters.has(filterId);
  });
};

export const collectOrderBotFilters = (orders: ICexOrder[]): Set<ECexBotFilter> => {
  return orders.reduce<Set<ECexBotFilter>>((acc, order) => {
    acc.add(mapCexBotToFilter(order.bot));
    return acc;
  }, new Set());
};
